<pux-translate v-if="object.type &amp;&amp; placeholder" tag="span" :html="placeholder.text" :extra="placeholder.extra"></pux-translate>